module.exports = __webpack_public_path__ + "static/media/noImage2.d6074db4.png";